export default __webpack_public_path__ + "static/media/logo_intheblack_default.811ebbab.svg";